import moment from 'moment';
import 'moment/locale/es';

export const convertToCamelCase = (string = '') => {
  const str = string.toLowerCase();
  const arr = str.split(' ');
  for (let i = 0; i < arr.length; i++) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
  }
  const str2 = arr.join(' ');
  return str2;
};

export const filterTokenByIntegrationId = (tokens, integrationId) => {
  if (typeof tokens === 'string') {
    return { token: tokens };
  }
  if (tokens?.length) {
    let filterToken = [];
    let token = null;
    if (tokens && integrationId) {
      filterToken = tokens?.filter(e => e.split('-')[0] == integrationId);
    }
    if (filterToken && !!filterToken.length) {
      token = filterToken[0]
        .split('-')
        .splice(1, filterToken[0].split('-').length - 1)
        .join('-');
      return {
        token,
      };
    }
  }
  return;
};

// Un hotel puede traer varias rates (una por régimen de comida); esto elige
// la más barata para usarla como "la" rate representativa del hotel en
// sorts/filtros que antes asumían una sola rate por hotel.
export const getCheapestRate = (rates, getPrice = defaultRatePrice) => {
  if (!Array.isArray(rates) || !rates.length) {
    return undefined;
  }

  return rates.reduce((cheapest, rate) =>
    getPrice(rate) < getPrice(cheapest) ? rate : cheapest
  );
};

const defaultRatePrice = rate => rate?.price?.details_USD?.total ?? Infinity;

export const sortRoomsByPrice = (rates, hotels = false) => {
  if (!Array.isArray(rates)) {
    return [];
  }

  const getPrice = item =>
    item.price?.details?.total_with_out_taxes ?? Infinity;
  const getItem = item =>
    hotels ? getCheapestRate(item.rates, getPrice) : item;
  const getAvailability = item => item.rooms?.[0]?.availability ?? '';

  return [...rates].sort((x, y) => {
    const a = getItem(x);
    const b = getItem(y);

    const aAvail = getAvailability(a);
    const bAvail = getAvailability(b);

    if (aAvail === 'ORQ' && bAvail !== 'ORQ') {
      return 1;
    }
    if (bAvail === 'ORQ' && aAvail !== 'ORQ') {
      return -1;
    }

    return getPrice(a) - getPrice(b);
  });
};

export const moneyTypes = id => {
  let money;
  if (id === 1) {
    money = 'USD ';
  } else if (id === 2) {
    money = 'EUR ';
  } else if (id === 3) {
    money = '$ ';
  }
  return money;
};

export const orderByName = data => {
  data.sort(function (a, b) {
    var nameA = a.name.toUpperCase();
    var nameB = b.name.toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  });
  return data;
};

export function calculateInclusiveDays(start_date, end_date) {
  const start = moment(start_date, 'DD/MM/YYYY', true);
  const end = moment(end_date, 'DD/MM/YYYY', true);

  if (!start.isValid() || !end.isValid()) {
    return '';
  }

  return end.diff(start, 'days') + 1;
}

export function orderHotelsById(orderHotelsBy, hoteles) {
  const ratePrice = rate =>
    rate?.price?.details?.total_with_out_taxes ?? Infinity;
  const getPrice = h => ratePrice(getCheapestRate(h.rates, ratePrice));
  const getPriority = h => (h.priority !== undefined ? h.priority : Infinity);

  const comparators = {
    1: (a, b) => getPriority(a) - getPriority(b) || getPrice(a) - getPrice(b),
    2: (a, b) => getPrice(a) - getPrice(b),
    3: (a, b) => getPrice(b) - getPrice(a),
    0: () => 0,
  };

  return hoteles.sort(comparators[orderHotelsBy] ?? (() => 0));
}

export function toReadableDate(date) {
  if (!date) {
    return '';
  }
  return moment(date, 'DD/MM/YYYY').locale('es').format('D MMMM YYYY');
}
